import { produce, Draft } from 'immer';

// @ts-ignore
export const update = <T>(x: T, h: (a: Draft<T>) => any): T => produce(x, d => {
  h(d);
  return d;
});
